import { render, staticRenderFns } from "./OverseasReport.vue?vue&type=template&id=70d01df1&scoped=true"
import script from "./OverseasReport.vue?vue&type=script&lang=js"
export * from "./OverseasReport.vue?vue&type=script&lang=js"
import style0 from "./OverseasReport.vue?vue&type=style&index=0&id=70d01df1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d01df1",
  null
  
)

export default component.exports